<template>
    <div>
        <div v-if="!loaded" class="enqContent d-flex align-items-center">
            <strong>{{ __('Loading...') }}</strong>
            <div class="spinner-border ml-auto" role="status" aria-hidden="true"></div>
        </div>

        <div v-else class="enqContent"><i v-if="disabled" class="fragment-disabled"></i>
            <div v-if="filteredPOs && filteredPOs.length > 0">
                <div class="form form-inline">
                    <div
                        class="form-group align-items-center w-100"
                        v-for="(po, idx) in filteredPOs"
                        :key="po.ID"
                    >
                        <label
                            :for="'po' + po.ID"
                            class="d-block d-xl-none col-xs-12 control-label text-left my-1"
                        >
                            <strong v-if="0 === idx">{{ __('Purchase Orders') }}</strong>
                        </label>
                        <label
                            :for="'po' + po.ID"
                            class="d-none d-xl-block col-xl-3 control-label text-right"
                        >
                            <strong v-if="0 === idx">{{ __('Purchase Orders') }}</strong>
                        </label>

                        <div class="col-xs-12 col-xl-9 w-100">
                            <a
                                :id="'po' + po.ID"
                                class="a-input btn-link"
                                @click.prevent="selectFragment('purchase-order', po.ID)"
                                href="#"
                            >{{ po.POID ? po.POID + ': ' + po.supplier.supplierName : po.supplier.supplierName }}</a>
                        </div>
                    </div>
                    <div class="mb-1"></div>
                </div>

                <hr v-if="filteredPOs.length > 1">
            </div>

            <div v-if="this.enquiry.cancelled_purchase_orders && this.enquiry.cancelled_purchase_orders.length > 0">
                <div class="form form-inline">
                    <div
                        class="form-group align-items-center w-100"
                        v-for="(po, idx) in this.enquiry.cancelled_purchase_orders"
                        :key="po.ID"
                    >
                        <label
                            :for="'po' + po.ID"
                            class="d-block d-xl-none col-xs-12 control-label text-left my-1"
                        >
                            <strong v-if="0 === idx">{{ __('Cancelled Purchase Orders') }}</strong>
                        </label>
                        <label
                            :for="'po' + po.ID"
                            class="d-none d-xl-block col-xl-3 control-label text-right"
                        >
                            <strong v-if="0 === idx">{{ __('Cancelled Purchase Orders') }}</strong>
                        </label>

                        <div class="col-xs-12 col-xl-9 w-100">
                            <a
                                :id="'po' + po.ID"
                                class="a-input btn-link"
                                @click.prevent="selectFragment('purchase-order', po.ID)"
                                href="#"
                            >{{ po.POID ? po.POID + ': ' + po.supplier.supplierName : po.supplier.supplierName }}</a>
                        </div>
                    </div>
                    <div class="mb-1"></div>
                </div>

                <hr v-if="this.enquiry.cancelled_purchase_orders.length > 1">
            </div>

            <div class="form form-inline">
                <div
                    class="form-group align-items-center w-100 mb-1"
                >
                    <label
                        for="deliveryNote"
                        class="d-block d-xl-none col-xs-12 control-label text-left my-1"
                    >
                        <strong>{{ __('Delivery Note') }}</strong>
                    </label>
                    <label
                        for="deliveryNote"
                        class="d-none d-xl-block col-xl-3 control-label text-right"
                    >
                        <strong>{{ __('Delivery Note') }}</strong>
                    </label>

                    <div class="col-xs-12 col-xl-9 w-100">
                        <a
                            id="deliveryNote"
                            class="a-input btn-link"
                            @click.prevent="selectFragment('delivery-note')"
                            href="#"
                        >{{ __('Generate') }}</a>
                    </div>
                </div>

                <div
                    class="form-group align-items-center w-100 mb-1"
                >
                    <label
                        for="quote"
                        class="d-block d-xl-none col-xs-12 control-label text-left my-1"
                    >
                        <strong>{{ __('Quote') }}</strong>
                    </label>
                    <label
                        for="quote"
                        class="d-none d-xl-block col-xl-3 control-label text-right"
                    >
                        <strong>{{ __('Quote') }}</strong>
                    </label>

                    <div class="col-xs-12 col-xl-9 w-100">
                        <a
                            id="quote"
                            class="a-input btn-link"
                            :href="enquiry.quote_url"
                            target="_blank"
                        >{{ __('Download') }}</a>
                    </div>
                </div>
                <div
                    class="form-group align-items-center w-100 mb-1"
                >
                    <label
                        for="orderConfirmation"
                        class="d-block d-xl-none col-xs-12 control-label text-left my-1"
                    >
                        <strong>{{ __('Order Confirmation') }}</strong>
                    </label>
                    <label
                        for="orderConfirmation"
                        class="d-none d-xl-block col-xl-3 control-label text-right"
                    >
                        <strong>{{ __('Order Confirmation') }}</strong>
                    </label>

                    <div class="col-xs-12 col-xl-9 w-100">
                        <a
                            id="orderConfirmation"
                            class="a-input btn-link"
                            @click.prevent="selectFragment('order-confirmation')"
                            href="#"
                        >{{ __('Generate') }}</a>
                    </div>
                </div>
                <div
                    class="form-group align-items-center w-100 mb-1"
                >
                    <label
                        for="proforma"
                        class="d-block d-xl-none col-xs-12 control-label text-left my-1"
                    >
                        <strong>{{ __('Proforma Invoice') }}</strong>
                    </label>
                    <label
                        for="proforma"
                        class="d-none d-xl-block col-xl-3 control-label text-right"
                    >
                        <strong>{{ __('Proforma Invoice') }}</strong>
                    </label>

                    <div class="col-xs-12 col-xl-9 w-100">
                        <a
                            id="proforma"
                            class="a-input btn-link"
                            @click.prevent="selectFragment('proforma')"
                            href="#"
                        >{{ __('Generate') }}</a>
                    </div>
                </div>
                <div
                    class="form-group align-items-center w-100 mb-1"
                >
                    <label
                        for="invoice"
                        class="d-block d-xl-none col-xs-12 control-label text-left my-1"
                    >
                        <strong>{{ __('Invoice') }}</strong>
                    </label>
                    <label
                        for="invoice"
                        class="d-none d-xl-block col-xl-3 control-label text-right"
                    >
                        <strong>{{ __('Invoice') }}</strong>
                    </label>

                    <div class="col-xs-12 col-xl-9 w-100">
                        <a
                            id="invoice"
                            class="a-input btn-link"
                            @click.prevent="selectFragment('invoice')"
                            href="#"
                        >{{ __('Generate') }}</a>
                    </div>
                </div>
            </div>

            <!-- $activeUser->hasPermission('creditNotes') -->
            <div v-if="true || (enquiry.issued_credit_notes && enquiry.issued_credit_notes.length > 0)">
                <hr>

                <div class="form form-inline">
                    <div
                        class="form-group align-items-center w-100 mb-1"
                    >
                        <label
                            for="creditNote"
                            class="d-block d-xl-none col-xs-12 control-label text-left my-1"
                        >
                            <strong>{{ __('New Credit Note') }}</strong>
                        </label>
                        <label
                            for="creditNote"
                            class="d-none d-xl-block col-xl-3 control-label text-right"
                        >
                            <strong>{{ __('New Credit Note') }}</strong>
                        </label>

                        <div class="col-xs-12 col-xl-9 w-100">
                            <a
                                id="creditNote"
                                class="a-input btn-link"
                                :href="newCreditNoteRoute"
                            >{{ __('Generate') }}</a>
                        </div>
                    </div>
                </div>

                <hr v-if="enquiry.issued_credit_notes && enquiry.issued_credit_notes.length > 1">

                <div class="form form-inline">
                    <div
                        class="form-group align-items-center w-100"
                        v-for="(cn, idx) in enquiry.issued_credit_notes"
                        :key="cn.ID"
                    >
                        <label
                            :for="'cn' + cn.ID"
                            class="d-block d-xl-none col-xs-12 control-label text-left my-1"
                        >
                            <strong v-if="0 === idx">{{ __('Existing Credit Notes') }}</strong>
                        </label>
                        <label
                            :for="'cn' + cn.ID"
                            class="d-none d-xl-block col-xl-3 control-label text-right"
                        >
                            <strong v-if="0 === idx">{{ __('Existing Credit Notes') }}</strong>
                        </label>

                        <div class="col-xs-12 col-xl-9 w-100">
                            <a
                                :id="'cn' + cn.ID"
                                class="a-input btn-link"
                                :href="creditNoteRoute.replace('XXXXX', cn.ID)"
                            >CN-{{ cn.CNID }}</a>
                        </div>
                    </div>
                    <div class="mb-1"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "EnqFragmentDocuments",

    props: {
        enquiry: {
            required: true,
            type: Object
        },

        selectFragment: {
            required: true,
            type: Function
        },

        updateEnquiry: {
            required: true,
            type: Function
        },

        disabled: {
            required: true,
            type: Boolean
        }
    },

    data() {
        return {
            loaded: false,

            newCreditNoteRoute: "",
            creditNoteRoute: ""
        };
    },

    computed: {},

    methods: {},

    mounted() {
        axios
            .post("/api/enquiries/fragment/documents/get", {
                enquiryID: this.enquiry.id,
                order: this.order
            })
            .then(response => {
                // console.log(response);

                let data = response.data;
                if (!data.success) {
                    $("#fail-alert")
                        .text(data.message || "Unknown error")
                        .slideDown(500)
                        .delay(5000)
                        .slideUp(500);
                } else {
                    this.loaded = true;
                    this.updateEnquiry(data.enquiry);

                    this.newCreditNoteRoute = data.newCreditNoteRoute;
                    this.creditNoteRoute = data.creditNoteRoute;
                    this.filteredPOs = data.filteredPOs;
                }
            })
            .catch(error => {
                console.error(error.response);

                $("#fail-alert")
                    .text(error.toString() || "Unknown error")
                    .slideDown(500)
                    .delay(5000)
                    .slideUp(500);
            });
    }
};
</script>
